/**
 * @GENERATED from Figma node 693:15949
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const QuipBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#F27557"
      d="M18.53 12.004c0 .423-.35.774-.773.774H6.236a.78.78 0 0 1-.773-.774c0-.423.35-.773.773-.773h11.536c.423 0 .758.335.758.773m-3.077 4.232H8.54a.766.766 0 0 1-.044-1.532h6.971c.423 0 .773.35.773.773s-.35.759-.787.759M8.54 7.773h6.927c.423 0 .773.35.773.773s-.35.773-.773.773H8.54a.78.78 0 0 1-.773-.773c0-.423.35-.773.773-.773m9.246-1.941a8.36 8.36 0 0 0-5.79-2.291c-.175 0-.364 0-.54.014a8.456 8.456 0 0 0-7.903 7.91c-.146 2.363.656 4.61 2.275 6.332a8.41 8.41 0 0 0 6.168 2.67h8.46v-8.463a8.31 8.31 0 0 0-2.67-6.172"
    />
    <path
      fill="#C34027"
      d="M20.454 20.468h-8.458a8.38 8.38 0 0 1-6.17-2.67c-1.618-1.722-2.42-3.97-2.274-6.333a8.456 8.456 0 0 1 7.904-7.91c.19-.014.364-.014.554-.014 2.159 0 4.23.817 5.79 2.291a8.37 8.37 0 0 1 2.669 6.173v8.463zm-1.619-15.76a9.83 9.83 0 0 0-7.481-2.684c-5.017.306-9.027 4.333-9.334 9.338a9.93 9.93 0 0 0 2.698 7.486A9.98 9.98 0 0 0 11.996 22h9.231c.423 0 .773-.35.773-.773V11.99a10.1 10.1 0 0 0-3.165-7.282"
    />
    <path
      fill="#FEFEFE"
      d="M15.452 14.69H8.539a.78.78 0 0 0-.773.773c0 .423.35.773.773.773h6.927c.423 0 .773-.35.773-.773a.79.79 0 0 0-.788-.774M8.539 9.304h6.927c.423 0 .773-.35.773-.774a.78.78 0 0 0-.773-.773H8.54a.78.78 0 0 0-.773.773c0 .424.35.774.773.774M6.235 11.23a.766.766 0 0 0 0 1.532H17.77c.423 0 .773-.35.773-.773a.78.78 0 0 0-.773-.774z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(QuipBright);
export { ForwardRef as QuipBright };
